import {IsOptional, IsString} from 'class-validator';

export class UpdatePasswordDto {
  @IsOptional()
  @IsString()
  oldPassword?: string;

  @IsString()
  newPassword!: string;
}
